import './About.css';

const stats = [
  { value: '15+', label: 'Jaar ervaring' },
  { value: '10-49', label: 'Medewerkers' },
  { value: '500+', label: 'Succesvolle plaatsingen' },
  { value: '25+', label: "Regio's" },
];

const values = [
  { title: 'Professionalisme', desc: 'Vakbekwame medewerkers, geselecteerd op certificering en ervaring.' },
  { title: 'Partnership', desc: 'Wij denken mee als partner, niet als leverancier op afstand.' },
  { title: 'Veiligheid', desc: 'Safety-first benadering op elke werf en elk project.' },
  { title: 'Kwaliteit', desc: 'Gecertificeerd personeel, geen ongeschoolde invulling.' },
];

const About = () => {
  return (
    <section className="about" id="over-ons">
      <div className="about-container">
        {/* Header */}
        <div className="about-header">
          <span className="about-label">Over ons</span>
          <h2 className="about-title">
            Technisch personeel voor scheepswerven, bouw en industrie in Rotterdam
          </h2>
          <p className="about-mission">
            Özel Uitzendbureau B.V. levert gecertificeerde lassers, ijzerwerkers,
            brandwachten en scheepstimmerlieden aan opdrachtgevers in de haven, bouw,
            metaal en industrie. Van werving tot plaatsing beschouwen wij onze
            opdrachtgevers als partner en denken wij actief mee met de planning.
          </p>
        </div>

        {/* Stats — content-width spec strip, not a card grid */}
        <dl className="about-specs">
          {stats.map((stat) => (
            <div key={stat.label}>
              <dt>{stat.label}</dt>
              <dd>{stat.value}</dd>
            </div>
          ))}
        </dl>

        {/* Values — hairline-separated list, not a card grid */}
        <div className="about-values">
          <h3 className="about-values-heading">Waar wij voor staan</h3>
          <ul className="about-values-list">
            {values.map((value) => (
              <li key={value.title}>
                <span className="value-title">{value.title}</span>
                <span className="value-desc">{value.desc}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Trust */}
        <div className="about-trust">
          <span className="trust-label">KVK</span>
          <span className="trust-value">24397850</span>
        </div>
      </div>
    </section>
  );
};

export default About;
